<template>
  <div>
    <GlobalInfoBar
      title="导入白名单"
      subtitle="上传OPPO每日白名单数据表，导入后设备进入待生效列表"
    />

    <GlobalChunk title="导入说明" :padding="[20, 20, 20, 20]">
      <div class="annotation-box">
        1. 支持 .xlsx / .xls / .csv 格式文件上传<br />
        2. 文件必须包含字段：品牌、机型、容量、指导价、IMEI号<br />
        3. IMEI号不可重复，重复数据自动跳过<br />
        4. 导入后设备状态默认为「待生效」
      </div>
      <el-upload
        class="upload-zone"
        drag
        action="#"
        :auto-upload="false"
        :show-file-list="false"
        accept=".xlsx,.xls,.csv"
        :on-change="handleFileChange"
        :disabled="importing"
      >
        <i class="el-icon-upload" style="font-size: 42px; color: #c0c4cc"></i>
        <div style="font-size: 14px; color: #555; font-weight: 500">
          点击或拖拽文件到此处上传
        </div>
        <div style="font-size: 12px; color: #999; margin-top: 6px">
          支持 xlsx、xls、csv 格式，单次最大 10MB
        </div>
      </el-upload>
      <div v-if="importing" style="margin-top: 16px">
        <div style="display:flex; justify-content:space-between; margin-bottom:6px; font-size:13px; color:#606266"><span>正在导入 {{ pendingFileName }}</span><span>{{ uploadProgress }}%</span></div>
        <el-progress :percentage="uploadProgress" />
      </div>


      <div
        v-if="uploadResult"
        style="
          margin-top: 16px;
          padding: 14px;
          background: #f6ffed;
          border: 1px solid #b7eb8f;
          border-radius: 8px;
          font-size: 13px;
        "
      >
        <strong style="color: #52c41a">✅ 上传成功</strong>
        <span style="margin-left: 12px; color: #555"
          >{{ uploadResult.name }} 
          <!-- · 共 {{ uploadResult.total }} 条 · 成功
          {{ uploadResult.success }} 条 -->
           </span
        >
      </div>
    </GlobalChunk>

    <GlobalChunk
      title="导入历史"
      :padding="[20, 20, 20, 20]"
      style="margin-top: 20px"
    >
      <GlobalTable
        ref="GlobalTable"
        :columns="tableColumns"
        :data="tableData"
        :isIndex="false"
        :isPagination="true"
        :currentPage="curPage"
        :total="total"
        :pageSize="pageSize"
        @handleCurrentChange="currentChange"
      >
        <el-table-column slot="success" label="成功" align="center" width="120">
          <template slot-scope="{ row }">
            <span style="color: #67c23a; font-weight: bold">{{
              row.success_num
            }}</span>
          </template>
        </el-table-column>
        <el-table-column slot="fail" label="失败" align="center" width="120">
          <template slot-scope="{ row }">
            <span
              :style="row.fail_num > 0 ? 'color:#f56c6c;font-weight:bold;' : ''"
              >{{ row.fail_num }}</span
            >
          </template>
        </el-table-column>
        <el-table-column slot="action" label="操作" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="downloadFile(row)">下载结果</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

  </div>
</template>

<script>
import _api from "@/utils/request";

export default {
  name: "导入白名单",
  data() {
    return {
      uploadResult: null,
      importing: false,
      pendingFileName: "",
      uploadProgress: 0,
      tableColumns: [
        { prop: "add_time", label: "导入时间" },
        { prop: "title", label: "文件名" },
        { prop: "total_num", label: "总条数" },
        { slotName: "success" },
        { slotName: "fail" },
        { prop: "user_name", label: "操作人" },
        { slotName: "action" },
      ],
      tableData: [],
      curPage: 1,
      total: 0,
      pageSize: 10,
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      _api
        .importHistory({ page: this.curPage, limit: this.pageSize, model: 1 })
        .then((res) => {
          if (res) {
            this.tableData = res.data || [];
            this.total = res.count || 0;
          }
        })
        .catch(() => {});
    },
    currentChange(page) {
      this.curPage = page;
      this.fetchList();
    },
    handleFileChange(file) {
      if (!file || this.importing || !file.raw) return;
      this.pendingFileName = file.name;
      this.uploadProgress = 0;
      const formData = new FormData();
      formData.append("file", file.raw);
      this.importing = true;
      _api
        .importStock(formData, {
          onUploadProgress: (event) => {
            if (event.lengthComputable) this.uploadProgress = Math.min(99, Math.round((event.loaded / event.total) * 100));
          },
        })
        .then((res) => {
          if (res) {
            this.uploadResult = {
              name: this.pendingFileName,
              total: res.data && res.data.total_num ? res.data.total_num : 0,
              success: res.data && res.data.success_num ? res.data.success_num : 0,
            };
          }
          this.uploadProgress = 100;
          this.$message({ type: "success", message: "文件导入成功！" });
          this.fetchList();
        })
        .catch(() => this.$message({ type: "error", message: "文件导入失败" }))
        .finally(() => { this.importing = false; });
    },
    downloadFile(row) {
      const id = row.id || row.log_id || row.import_id;
      if (!id) {
        this.$message({ type: "info", message: "暂无下载记录" });
        return;
      }
      _api.importResultDownload({ id, log_id: id }).then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = row.title || "导入结果.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
      }).catch(() => {
        this.$message({ type: "error", message: "下载结果失败" });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.annotation-box {
  background: #f0f5ff;
  border-left: 4px solid #1890ff;
  padding: 12px 16px;
  border-radius: 0 8px 8px 0;
  margin: 12px 0;
  font-size: 12px;
  color: #0050b3;
  line-height: 1.8;
}
.upload-zone {
  ::v-deep .el-upload-dragger {
    width: 100%;
    padding: 48px 0;
    border-radius: 12px;
  }
}

</style>
